"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DataTable = _interopRequireDefault(require("./tableComponents/DataTable"));
var _DataTableMobile = _interopRequireDefault(require("./tableComponents/DataTableMobile"));
var _TableModule = _interopRequireDefault(require("./Table.module.scss"));
var _icon = _interopRequireDefault(require("../icon/icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Table = function Table(_ref) {
  var title = _ref.title,
    copy = _ref.copy,
    tableRowsProps = _ref.tableRowsProps,
    columns = _ref.columns,
    _ref$collapseText = _ref.collapseText,
    collapseText = _ref$collapseText === void 0 ? 'Show all cover details' : _ref$collapseText,
    _ref$expandedText = _ref.expandedText,
    expandedText = _ref$expandedText === void 0 ? 'Show less cover details' : _ref$expandedText;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  var _useState5 = (0, _react.useState)(tableRowsProps.slice(0, 3)),
    _useState6 = _slicedToArray(_useState5, 2),
    finalArrayProps = _useState6[0],
    setFinalArrayProps = _useState6[1];
  var tableWrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      setIsMobile(window.innerWidth <= 600);
    };
    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (showAll) {
      setFinalArrayProps(tableRowsProps);
    } else {
      setFinalArrayProps(tableRowsProps.slice(0, 3));
    }
  }, [showAll, tableRowsProps]);
  var handleShowAll = function handleShowAll() {
    setShowAll(!showAll);
    if (tableWrapperRef.current && showAll) {
      tableWrapperRef.current.scrollIntoView({
        behavior: 'auto'
      });
    }
  };
  var ShowButton = function ShowButton() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: _TableModule["default"].showAllButton,
      onClick: handleShowAll,
      "aria-expanded": showAll,
      "aria-controls": "table-content",
      children: showAll ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
          name: "chevron-up",
          className: _TableModule["default"].buttonIcon
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: expandedText
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
          name: "chevron-down",
          className: _TableModule["default"].buttonIcon
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _TableModule["default"].buttonText,
          children: collapseText
        })]
      })
    });
  };
  var mobileContents = columns.map(function (column, index) {
    var _column$image, _column$image2;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: ((_column$image = column.image) === null || _column$image === void 0 ? void 0 : _column$image.mobile) || '',
        alt: ((_column$image2 = column.image) === null || _column$image2 === void 0 ? void 0 : _column$image2.altText) || '',
        className: _TableModule["default"].columnImageMobile
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: _TableModule["default"].topMobileText,
        children: index === 0 ? 'Bronze' : index === 1 ? 'Silver' : 'Gold'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: index === 0 ? _TableModule["default"].bronzeBottomMobile : index === 1 ? _TableModule["default"].silverBottomMobile : _TableModule["default"].goldBottomMobile
      })]
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _TableModule["default"].tableWrapper,
    "aria-label": title,
    ref: tableWrapperRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: title
    }), copy && /*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
      children: [" ", copy, " "]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TableModule["default"].desktopTable,
      "aria-hidden": isMobile,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTable["default"], {
        tableRowsProps: finalArrayProps,
        columns: columns,
        title: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _TableModule["default"].mobileTable,
      "aria-hidden": !isMobile,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTableMobile["default"], {
        value0: "Maximum we'll pay for:",
        columns: columns.map(function (column, index) {
          return {
            value: mobileContents[index],
            color: column.accentColour
          };
        }),
        isTopRow: true
      }), finalArrayProps.map(function (rowProps, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTableMobile["default"], {
          value0: rowProps.value0,
          copy: rowProps.copy,
          columns: rowProps.columns,
          rowHasAccentColours: true
        }, index);
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ShowButton, {})]
  });
};
var _default = exports["default"] = Table;